export enum FgPriceListCategoryEnum{
    LOCAL='LOCAL',
    EXPORT='EXPORT',
    UB = 'UB'

}